import React, { useEffect, useState } from 'react';
import { Button, Card, Checkbox, Form, Input, Space } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/ImagePicker"
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import InputNumber from 'components/input-number';
import { formatCurrency } from "utils/number"
const service = new StoreSettingService();

const OrderSetting = () => {
    const [form] = useForm();
    const { showLoading, showNotify } = useApp();
    const [oldSetting, setOldSetting] = useState({})

    useEffect(() => {
        loadData();
    }, []);



    const loadData = async () => {
        var setting = await service.getShippingfeeSetting();
        form.setFieldsValue(setting);
        setOldSetting(setting);
    }

    const onFinish = async values => {
      //  console.log('Success:', values);
        showLoading(true);
        await service.saveShippingfeeSetting(values)
        await loadData();
        showLoading(false);
        showNotify("Đã cập nhật")
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };
    return (

        <Card>
            <Form
                form={form}
                name="basic"
                layout='vertical'
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >


                <Form.Item
                    label="Phí ship chung"
                    name="flat_fee"
                    rules={[{
                        required: true,

                    },

                    ]}
                
                >
                    <InputNumber />
                </Form.Item>
                <div style={{ display: "flex", gap: 8, marginBottom:8 }}>
                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
                        <Form.Item
                            layout='horizontal'

                            name="free_ship"
                            rules={[{
                                required: true,

                            },

                            ]}
                            noStyle
                            valuePropName='checked'
                        >
                            <Checkbox />
                        </Form.Item>
                    </div>
                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
                        <label>Miễn phi ship cho đơn hàng trên</label>
                    </div>

                    <div>

                        <Form.Item
                            noStyle
                            name="free_shipping_threshold"
                            layout='vertical'
                            rules={[{
                                required: false,

                            },

                            ]}

                        >
                            <InputNumber />
                        </Form.Item>
                    </div>

                </div>





              

                <Form.Item label={null}>
                    <Button type="primary" htmlType="submit">
                        Cập nhật
                    </Button>
                </Form.Item>
            </Form>

        </Card>
    )
}
export default OrderSetting;